<template>
  <div>
    <section class="section">
      <!-- 3/12カラム構成 -->
      <div class="columns">
        <div class="column is-3-tablet is-2-desktop">
          <!-- 検索コンポーネント -->
          <span class="has-text-weight-bold" v-if="taskListData.length === 0">検索結果はありません</span>
          <searchComponet @getSearch="getSearch($event)" :daterange="daterange" :isToggleActive="isToggleActive"></searchComponet>
          <!-- 車両表示・非表示 -->
          <template v-if="modules.module_location">
            <template v-if="user.permission.admin">
              <div class="colmun">
                <p class="is-size-4 has-text-primary">
                  車両の表示
                </p>
                <a v-bind:class="[isCarShow === true ? 'button is-info' : 'button']" @click="carsStateChange" v-bind:disabled="trakings.length === 0">{{ carsShowMsg }}</a>
              </div>
            </template>
          </template>
        </div>
        <div class="column is-9-tablet is-10-desktop">
          <mapComponent ref="maps" @taskMessage="taskCreateEnd($event)" :isCarShow="isCarShow"></mapComponent>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import map_component from '../components/map-component'
import search_componet from '../components/search_menu'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  data: function() {
    return {
      limit: 50000,
      page:1,
      showModal: false,
      isNotification: false,
      intervalId: undefined,
      search_params:{
        fk_urgency: '',
        fk_status_id: '',
        fk_mode: '',
        fk_register_id: '',
        fk_rep_id: '',
        mapshow: 1,
      },
      isToggleActive: false,
      daterange:{
        to: '',
        from: '',
      },
      isCarShow:false,
      carsShowMsg: '非表示中',
    }
  },
  components: {
    'mapComponent': map_component,
    'searchComponet': search_componet,
  },
  computed:{
    ...mapState({
      user: state => state.auth.user,
      modules: state => state.auth.modules,
      apiStatus: state => state.task.apiStatus,
      taskListData: state => state.task.tasks,
      trakings: state => state.item.trakings,
      apiTrakingStatus: state => state.item.apiTrakingStatus
    }),
  },
  mounted() {
    let today = moment().format("YYYY-MM-DD")
    this.daterange.from = moment(today).add(-1, 'W').format("YYYY-MM-DD")  //1ヶ月前からデータに絞り込み
    this.daterange.to = today
    //マップ描画用データ取得
    this.getTaskData()
    //初回車両データ取得
    this.carsLoader()
    this.intervalId = setInterval(this.carsLoader, 10000)
  },
  beforeDestroy () {
    clearInterval(this.intervalId)
  },
  methods: {
    async carsLoader(){
      await this.$store.dispatch('item/getTracking', {})
      if(this.apiTrakingStatus){
        this.$refs.maps.createCars(this.trakings)
      }
    },
    async getTaskData(){
      this.$set(this, 'isToggleActive', false)
      this.$store.dispatch('task/clearTasks')
      this.$refs.maps.mapClear()
      await this.$store.dispatch('task/getTaskList',
        {
          search_params: this.search_params,
          daterange: this.daterange,
          limit: this.limit,
          page: this.page,
        }
      )
      if(this.apiStatus){
        this.$refs.maps.createTaskPoint(this.taskListData)
      }
    },
    taskCreateEnd(eventArgs){
      this.$set(this, 'isToggleActive', true)
    },
    getSearch(eventArgs){
      this.$set(this, 'search_params', eventArgs[0])
      this.$set(this, 'daterange', eventArgs[1])
      this.getTaskData()
    },
    carsStateChange(){
      this.isCarShow = !this.isCarShow
      this.$set(this, 'carsShowMsg', !this.isCarShow ? '非表示中' : '表示中')
    },
  }
}
</script>

